/*
  FWUSA free gift of a product promotion (snippets/fw-promo.liquid).
  The gift is a $0 variant of a hidden gift product. The note under the price carries
  data-fw-gift (the gift variant) and data-fw-gift-for (the product's variants).
  - When Dawn's product form adds one of those variants, the gift is added once, with the hidden
    line property _fw_gift_for listing the variants it belongs to, and the cart icon and
    notification (or the cart drawer) are refreshed. "Complete your kit" adds it itself
    (assets/fw-product.js).
  - On every page load and cart change, a gift line whose product is no longer in the cart is
    removed, and a gift line is kept at quantity 1, so the gift can't be checked out on its own
    or in bulk.
*/
(function () {
  "use strict";
  // Dawn declares subscribe and PUB_SUB_EVENTS as globals in pubsub.js and constants.js.
  var hasPubSub = typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined";
  var routes = window.routes || {};
  var busy = false;

  function getCart() {
    return fetch((routes.cart_url || "/cart") + ".js", { headers: { Accept: "application/json" } })
      .then(function (response) { return response.json(); });
  }

  function sectionHTML(html) {
    var el = new DOMParser().parseFromString(html, "text/html").querySelector(".shopify-section");
    return el ? el.innerHTML : null;
  }

  function cartSections() {
    var drawer = document.querySelector("cart-drawer");
    return drawer && drawer.getSectionsToRender
      ? drawer.getSectionsToRender().map(function (s) { return s.id; })
      : ["cart-icon-bubble", "cart-notification-button"];
  }

  function render(state) {
    if (!state || !state.sections) return;
    var drawer = document.querySelector("cart-drawer");
    if (drawer && drawer.renderContents) {
      drawer.renderContents(state);
      return;
    }
    Object.keys(state.sections).forEach(function (id) {
      var target = document.getElementById(id);
      var html = state.sections[id] && sectionHTML(state.sections[id]);
      if (target && html !== null) target.innerHTML = html;
    });
  }

  function addGift(gift, forIds) {
    return getCart().then(function (cart) {
      if (cart.items.some(function (item) { return item.variant_id === gift; })) return;
      return fetch((routes.cart_add_url || "/cart/add") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: gift, quantity: 1, properties: { _fw_gift_for: forIds.join(",") } }],
          sections: cartSections(),
          sections_url: window.location.pathname
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (state) { render(Object.assign({}, state, { id: gift })); });
    });
  }

  // Remove gift lines whose product left the cart and keep the others at quantity 1.
  // Returns true when the cart was changed.
  function fixGifts() {
    return getCart().then(function (cart) {
      var inCart = cart.items.map(function (item) { return item.variant_id; });
      var updates = {};
      var changed = false;
      cart.items.forEach(function (item) {
        var forIds = item.properties && item.properties._fw_gift_for;
        if (!forIds) return;
        var owned = String(forIds).split(",").map(Number).some(function (id) { return inCart.indexOf(id) !== -1; });
        if (!owned) { updates[item.key] = 0; changed = true; }
        else if (item.quantity > 1) { updates[item.key] = 1; changed = true; }
      });
      if (!changed) return false;
      return fetch((routes.cart_update_url || "/cart/update") + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates: updates })
      }).then(function () { return true; });
    });
  }

  function cleanUp() {
    // Dawn shows the count bubble only when the cart has items.
    if (!document.querySelector("#cart-icon-bubble .cart-count-bubble")) return;
    fixGifts()
      .then(function (removed) {
        // The cart page lists lines server side, so reload it to show the corrected gift line.
        if (removed && document.querySelector("cart-items")) window.location.reload();
      })
      .catch(function () {});
  }

  if (hasPubSub) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (busy || !event) return;
      if (event.source === "product-form") {
        var note = document.querySelector(".fw-promo[data-fw-gift]");
        if (!note) return;
        var forIds = (note.dataset.fwGiftFor || "").split(",").map(Number);
        var gift = Number(note.dataset.fwGift);
        if (!gift || forIds.indexOf(Number(event.productVariantId)) === -1) return;
        busy = true;
        addGift(gift, forIds).catch(function () {}).then(function () { busy = false; });
      } else {
        cleanUp();
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", cleanUp);
  } else {
    cleanUp();
  }
})();
